import React from 'react';
import styled from 'styled-components';
import api from '../services/api';

const instancia = process.env.REACT_APP_INSTANCIA;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 12px;
  width: 100%;
  max-width: 700px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.h2`
  margin-top: 0;
  font-size: 18px;
  color: #333;
  margin-bottom: 16px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const InputGroup = styled.div`
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 14px;
  margin-bottom: 4px;
  color: #555;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
`;

const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const SaveButton = styled(Button)`
  background-color: #6c5ce7;
  color: white;
`;

const CancelButton = styled(Button)`
  background-color: #ccc;
  color: #333;
`;

const ClienteSection = styled.div`
  margin-top: 16px;
`;

const ClienteNome = styled.p`
  margin-top: 8px;
  font-weight: bold;
  color: #2ecc71;
`;

const ChequeModal = ({ isOpen, onClose, onSave, initialData }) => {
    const [form, setForm] = React.useState({
        banco: '',
        numero: '',
        valor: '',
        emissao: '',
        vencimento: '',
        status: 'PENDENTE',
        observacao: '',
        cpfCnpj: '',
        nomeCliente: '',
        cod_cheque: 0
    });

    const [carregandoCliente, setCarregandoCliente] = React.useState(false);

    React.useEffect(() => {
        if (initialData) {
            const venctoFormatada = initialData.VENCIMENTO.split("T")[0];
            const emissaoFormatada = initialData.EMISSAO.split("T")[0];
            setForm({
                banco: initialData.BANCO || '',
                numero: initialData.NUMERO || '',
                valor: initialData.VALOR || '',
                emissao: emissaoFormatada || '',
                vencimento: venctoFormatada || '',
                status: initialData.STATUS || 'PENDENTE',
                observacao: initialData.observacao || '',
                cpfCnpj: initialData.CNPJ_CPF || '',
                nomeCliente: initialData.nome || '',
                cod_cheque: initialData.COD_CHEQUE
            });
        } else {
            setForm({
                banco: '',
                numero: '',
                valor: '',
                emissao: '',
                vencimento: '',
                status: 'PENDENTE',
                observacao: '',
                cpfCnpj: '',
                nomeCliente: '',
                cod_cheque: 0
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleBuscarCliente = async () => {
        const cpfCnpj = form.cpfCnpj.replace(/\D/g, '');
        if (!cpfCnpj || cpfCnpj.length < 11) {
            alert('Digite um CPF ou CNPJ válido.');
            return;
        }

        setCarregandoCliente(true);
        try {
            // Aqui você faria a chamada real para a API:
            const response = await api.get(`/clientes/${cpfCnpj}/${instancia}`);
            if (response.data.length === 0) {
                alert('Cliente não encontrado');
                setForm(prev => ({
                    ...prev,
                    nomeCliente: ''
                }));
            } else {
                setTimeout(() => {
                    setForm(prev => ({
                        ...prev,
                        nomeCliente: response.data[0].NOME
                    }));
                }, 800);
            }
            setCarregandoCliente(false);
        } catch (err) {
            setCarregandoCliente(false);
            alert('Erro ao buscar cliente.');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Overlay>
            <ModalContainer>
                <ModalHeader>{initialData ? 'Editar Cheque' : 'Novo Cheque'}</ModalHeader>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <InputGroup>
                            <Label>Banco</Label>
                            <Input
                                type="text"
                                name="banco"
                                value={form.banco}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>

                        <InputGroup>
                            <Label>Número do Cheque</Label>
                            <Input
                                type="text"
                                name="numero"
                                value={form.numero}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>

                        <InputGroup>
                            <Label>Valor</Label>
                            <Input
                                type="number"
                                step="0.01"
                                name="valor"
                                value={form.valor}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>
                    </Row>

                    {/* Data de Emissão e Vencimento */}
                    <Row>
                        <InputGroup>
                            <Label>Data de Emissão</Label>
                            <Input
                                type="date"
                                name="emissao"
                                value={form.emissao}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>

                        <InputGroup>
                            <Label>Data de Vencimento</Label>
                            <Input
                                type="date"
                                name="vencimento"
                                value={form.vencimento}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>
                    </Row>

                    {/* CPF/CNPJ + Botão Buscar */}
                    <InputGroup>
                        <Label>CPF / CNPJ</Label>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Input
                                type="text"
                                name="cpfCnpj"
                                value={form.cpfCnpj}
                                onChange={handleChange}
                                placeholder="000.000.000-00"
                                maxLength="18"
                                onInput={(e) => {
                                    let value = e.target.value.replace(/\D/g, '');

                                    if (value.length <= 11) {
                                        // CPF: 000.000.000-00
                                        value = value.replace(/(\d{3})(\d)/, '$1.$2');
                                        value = value.replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
                                        value = value.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
                                    } else {
                                        // CNPJ: 00.000.000/0000-00
                                        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
                                        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
                                        value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4');
                                        value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2}).*/, '$1.$2.$3/$4-$5');
                                    }

                                    e.target.value = value;
                                }}
                            />

                            <Button
                                type="button"
                                onClick={handleBuscarCliente}
                                disabled={carregandoCliente}
                                style={{
                                    backgroundColor: '#00bfae',
                                    color: 'white',
                                    fontWeight: 'bold'
                                }}
                            >
                                {carregandoCliente ? 'Buscando...' : 'Buscar'}
                            </Button>
                        </div>
                    </InputGroup>

                    {/* Nome do Cliente */}
                    {form.nomeCliente && (
                        <ClienteSection>
                            <strong>Cliente:</strong>
                            <ClienteNome>{form.nomeCliente}</ClienteNome>
                        </ClienteSection>
                    )}

                    {/* Status e Observação */}
                    {/* <InputGroup>
                        <Label>Status</Label>
                        <Select name="status" value={form.status} onChange={handleChange}>
                            <option value="ABERTO">Aberto</option>
                            <option value="BAIXADO">Baixado</option>
                            <option value="CANCELADO">Cancelado</option>
                        </Select>
                    </InputGroup> */}

                    <InputGroup>
                        <Label>Status</Label>
                        <Input
                            type="label"
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                            disabled
                        />
                    </InputGroup>

                    <InputGroup>
                        <Label>Observação (opcional)</Label>
                        <Input
                            as="textarea"
                            rows="3"
                            name="observacao"
                            value={form.observacao}
                            onChange={handleChange}
                        />
                    </InputGroup>

                    <ButtonGroup>
                        <CancelButton type="button" onClick={onClose}>
                            Cancelar
                        </CancelButton>
                        <SaveButton type="submit">
                            {initialData ? 'Atualizar' : 'Salvar'}
                        </SaveButton>
                    </ButtonGroup>
                </Form>
            </ModalContainer>
        </Overlay>
    );
};

export default ChequeModal;